{
    "Profile_UnderwriterCoverageAdjustment.header": "Underwriting",
    "Profile_UnderwriterCoverageAdjustment.premiums": "Premiums",
    "Profile_UnderwriterCoverageAdjustment.fees": "Fees",
    "Profile_UnderwriterCoverageAdjustment.discounts": "Discounts",
    "Profile_UnderwriterCoverageAdjustment.surcharge": "Surcharge",
    "Profile_UnderwriterCoverageAdjustment.modal.editTitle": "Edit {label}",
    "Profile_UnderwriterCoverageAdjustment.modal.addTitle": "Add {type} Adjustment",
    "Profile_UnderwriterCoverageAdjustment.modal.premiumType": "Premium",
    "Profile_UnderwriterCoverageAdjustment.modal.feeType": "Fee",
    "Profile_UnderwriterCoverageAdjustment.modal.discountType": "Discount",
    "Profile_UnderwriterCoverageAdjustment.modal.surchargeType": "Surcharge",
    "Profile_UnderwriterCoverageAdjustment.modal.currentAmount": "Current amount",
    "Profile_UnderwriterCoverageAdjustment.modal.adjustmentMethod": "Adjustment method",
    "Profile_UnderwriterCoverageAdjustment.modal.flatAmount": "Flat amount",
    "Profile_UnderwriterCoverageAdjustment.modal.absoluteAmount": "Absolute amount",
    "Profile_UnderwriterCoverageAdjustment.modal.percentage": "Percentage",
    "Profile_UnderwriterCoverageAdjustment.modal.value": "Value",
    "Profile_UnderwriterCoverageAdjustment.modal.description": "Description",
    "Profile_UnderwriterCoverageAdjustment.modal.cancel": "Cancel",
    "Profile_UnderwriterCoverageAdjustment.modal.apply": "Apply",
    "Profile_UnderwriterCoverageAdjustment.modal.rangeHelper": "Allowed range",
    "Profile_UnderwriterCoverageAdjustment.apply": "Apply Changes",
    "Profile_UnderwriterCoverageAdjustment.applied": "Applied"
}
